import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import * as S from './style';
import { useLocation, useNavigate } from 'react-router-dom';
import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';
import { useState } from 'react';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';
import PaymentModal from '@/components/common/Modal/PaymentModal/PaymentModal';
import { usePostAnnualFeePaidApi } from '@/api/payment';
import { CONF_TITLE } from '@/constants/menu';

const RegisterGuide = () => {
	const { showModal, closeModal } = useModalStore();
	const { isLogin } = useTokenStore();
	const [isOpen, setIsOpen] = useState(false);
	const [memberType, setMemberType] = useState('');
	const navigate = useNavigate();
	const location = useLocation();
	const params = location.state?.menu ?? '학술대회 안내';
	const depthParams = location.state?.depthMenu ?? '행사정보';
	const { mutateAsync: annualFeePaid } = usePostAnnualFeePaidApi();
	const handleCheckLogin = () => {
		if (isLogin()) {
			navigate('/conference', { state: { step: '등록 확인', menu: params, depthMenu: depthParams } });
		} else {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}
	};
	const handleRegister = async () => {
		const now = new Date();
		const koreaTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));
		const registrationOpenDate = new Date('2026-08-31T00:00:00+09:00');
		const deadline = new Date('2026-10-16T18:00:00+09:00');

		if (koreaTime < registrationOpenDate) {
			showModal('사전 등록 기간이 아닙니다.', 'confirm');
			return;
		}

		if (koreaTime >= deadline) {
			showModal('사전 등록 기간이 종료되었습니다.', 'confirm');
			return;
		}

		if (!isLogin()) {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}
		const res = await annualFeePaid({
			goods_name: CONF_TITLE,
		});
		if (res.data.success) {
			const memberType = res.data?.data?.member_type;
			setMemberType(memberType);

			if (memberType !== '정회원' && memberType !== '일반') {
				showModal('정회원/일반 회원만 사전등록이 가능합니다.', 'confirm');
				return;
			}

			setIsOpen(true);
		} else {
			if (res.data?.error.code === '78') {
				showModal('연회비 납부 후\n학회등록이 가능합니다.', 'twoBtn', '연회비 납부하기', () => navigate('/membership', { state: { menu: '연회비 납부' } }));
			} else if (res.data?.error.code === '80') {
				showModal('학회등록비 납부를\n이미 완료하셨습니다.', 'login', '확인', closeModal);
			} else {
				showModal('오류가 발생했습니다. 다시 시도해주세요.', 'register');
			}
		}
	};

	return (
		<S.Container>
			<S.ContentBox>
				<S.ContentTitle>기본정보</S.ContentTitle>
				<S.BasicInfoButtonBox>
					<S.BlueButton type="button" onClick={handleRegister}>
						회원 사전 등록
						<SingleArrowNext iconColor="#FFFFFF" width="20" height="20" />
					</S.BlueButton>
					<S.WhiteButton type="button" onClick={handleCheckLogin}>
						등록 확인
						<SingleArrowNext iconColor="#01337d" width="20" height="20" />
					</S.WhiteButton>
				</S.BasicInfoButtonBox>
				<S.BasicInfo>
					<li>회원의 경우 홈페이지 가입 후 연회비를 먼저 납부해야 등록이 가능합니다.</li>
					<li>추계학술대회는 한국노인과학학술단체의 연합학술대회로 진행하며, 포스터세션은 진행되지 않습니다.</li>
					<li>무통장 입금 결제의 경우 입금이 완료되어야 등록으로 처리됩니다.</li>
				</S.BasicInfo>
			</S.ContentBox>
			<S.ContentBox>
				<S.ContentTitle>등록비</S.ContentTitle>
				<S.Table>
					<S.TableHeadCell className="item2">구분</S.TableHeadCell>
					<S.TableHeadCell className="center">연회비</S.TableHeadCell>
					<S.TableHeadCell className="center">사전등록</S.TableHeadCell>
					<S.TableHeadCell className="center">현장등록</S.TableHeadCell>

					<S.TableCell className="item3 point">한국노화학회 회원</S.TableCell>
					<S.TableCell className="min-height point">정회원/일반</S.TableCell>
					<S.TableCell className="min-height center">80,000원</S.TableCell>
					<S.TableCell className="min-height center">70,000원</S.TableCell>
					<S.TableCell className="min-height center">80,000원</S.TableCell>

					<S.TableCell className="min-height point">학생회원/대학원생</S.TableCell>
					<S.TableCell className="min-height center">20,000원</S.TableCell>
					<S.TableCell className="min-height center">불가</S.TableCell>
					<S.TableCell className="min-height center">불가</S.TableCell>

					<S.TableCell className="item4 point">한국노화학회 비회원</S.TableCell>
					<S.TableCell className="min-height point">일반</S.TableCell>
					<S.TableCell className="min-height center">없음</S.TableCell>
					<S.TableCell className="min-height center" />
					<S.TableCell className="min-height center">100,000원</S.TableCell>

					<S.TableCell className="min-height point">대학원생</S.TableCell>
					<S.TableCell className="min-height center" />
					<S.TableCell className="min-height center" />
					<S.TableCell className="min-height center">불가</S.TableCell>

					<S.TableCell className="item6 min-height point">대학생/고등학생</S.TableCell>
					<S.TableCell className="min-height center" />
					<S.TableCell className="min-height center" />
					<S.TableCell className="min-height center">불가</S.TableCell>
				</S.Table>

				<S.HighlightBox>
					<span>사전등록마감:</span>
					<span className="point">2026년 10월 16일 18시까지</span>
				</S.HighlightBox>

				<S.ContentTitle>결제방법</S.ContentTitle>
				<S.BasicInfo>
					<li>카드결제를 이용하면 즉시 결제완료로 처리됩니다.</li>
					<li>무통장 입금 결제의 경우 입금이 완료되어야 등록으로 처리됩니다.</li>
					<li>입금 후 익일까지 등록완료로 변경되지 않을 경우 aging07@gmail.com 으로 메일주시기 바랍니다.</li>
				</S.BasicInfo>
			</S.ContentBox>
			<S.ContentBox>
				<S.ContentTitle>사전등록 취소 및 결제변경</S.ContentTitle>
				<S.PaymentBox>
					<S.PaymentContentName>행사 2주일 이전 환불 요청 시</S.PaymentContentName>
					<S.PaymentContent>100% 환불</S.PaymentContent>
					<S.PaymentContentName>행사 2주일전~행사당일</S.PaymentContentName>
					<S.PaymentContent className="danger">환불 불가</S.PaymentContent>
				</S.PaymentBox>
			</S.ContentBox>
			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<PaymentModal closeModal={setIsOpen} goodsName="등록비" memberType={memberType} />
					</ModalBox>
				</ModalPortal>
			)}
		</S.Container>
	);
};
export default RegisterGuide;
